import { render, staticRenderFns } from "./TicketDetailField.vue?vue&type=template&id=3d13c3d1&scoped=true"
import script from "./TicketDetailField.vue?vue&type=script&lang=js"
export * from "./TicketDetailField.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailField.vue?vue&type=style&index=0&id=3d13c3d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13c3d1",
  null
  
)

export default component.exports